/** NumberField — numeric input bound to one form key. Stores as string
 *  (matches existing BookingForm behaviour — backend coerces). */
import { Input } from "@/components/ui/input";
import { Field } from "../_shared";

export default function NumberField({ field, value, set }) {
  return (
    <Field label={field.label} required={field.required}>
      <Input
        type="number"
        data-testid={field.testid}
        value={value ?? ""}
        min={field.min}
        step={field.step}
        onChange={(e) => set(field.key, e.target.value)}
        placeholder={field.placeholder}
      />
    </Field>
  );
}
